const ADMIN = "ADMIN";
const BO_LOGISTIC_USER = "BO_LOGISTIC_USER";
const BO_CONSULTATION_USER = "BO_CONSULTATION_USER";
const BO_COASTAL_USER = "BO_COASTAL_USER";
const MOBILE = "MOBILE_USER";

export default {
    ADMIN,
    BO_LOGISTIC_USER,
    BO_CONSULTATION_USER,
    BO_COASTAL_USER,
    MOBILE,
    ALL_ROLES: [
        ADMIN,
        BO_LOGISTIC_USER,
        BO_CONSULTATION_USER,
        BO_COASTAL_USER,
        MOBILE
    ],
    BO: [
        ADMIN,
        BO_LOGISTIC_USER,
        BO_CONSULTATION_USER,
        BO_COASTAL_USER,
    ],
    BO_WITH_CRUD_RIGHTS: [
        ADMIN,
        BO_LOGISTIC_USER,
        BO_COASTAL_USER,
    ]
}